import React from 'react'

const MwInputText = (props) => {
    const {id,value='',defaultValue='',onChange,readOnly,disabled,label,invalid,invalidMsg,placeholder,size,onKeyDown,classNameInput,inputRef,inputType='text',style} = props
    const inputBaseClassName = `flex-1 w-full rounded-xl border bg-white px-3 text-xs text-slate-700 outline-none transition-all duration-200 ${
        size === 'sm' ? 'h-8' : 'h-11'
    } ${
        invalid ? 'border-red-400 focus:border-red-500 focus:ring-2 focus:ring-red-100' : 'border-slate-200 focus:border-[#251658]/40 focus:ring-2 focus:ring-[#251658]/10 hover:border-slate-300'
    } ${disabled ? 'cursor-not-allowed bg-slate-100 text-slate-400' : ''} ${classNameInput || ''}`
    return (
        <>
            { label && 
                <label className='block pb-1 px-1 text-xs font-medium text-[#251658]' htmlFor={id}>{label}</label>}
            
            { inputRef ?
            <input 
                ref={inputRef}
                type={inputType}
                className={inputBaseClassName}
                readOnly={readOnly}
                disabled={disabled}
                placeholder={placeholder}
                defaultValue={defaultValue}
                style={style}
            />
            :<input 
                type={inputType}
                className={inputBaseClassName}
                name={id} 
                
                value={value}  
                onChange={onChange} 
                onKeyDown={onKeyDown}
                readOnly={readOnly}
                disabled={disabled}
                placeholder={placeholder}
                style={style}
                />}
            { invalidMsg && <div className='px-1 pt-1 text-xs text-red-500'>{invalidMsg}</div> }
        </>
    )
}

export default MwInputText
